import {
  createClient,
  joinRoom,
  leaveRoom,
  createLocalStream,
  createShareStream,
} from "./tencent";
import {isEmpty} from "../utils"
import {Message} from 'element-ui'

export const fullVideoMixin = {
  data() {
    return {
      videos: [],
      audios: [],
      pulished: true
    }
  },
  created() {
    bus.$on('tecentInitSuccess', this.tencentJoinRoom)
    bus.$on('onCreateLocalStrem', this.createlocalMedia)
    bus.$on('onPublishLocalStream', this.publishLocal)
    bus.$on('onPublishShareStream', this.publishLocalShare)
    bus.$on('onReciveRemoteStrem', this.reciveRemoteMedia)
    bus.$on('onRemoteStreamRemove', this.removeRemoteMedia)
    bus.$on('onUnPublishShare', this.UnPublishShare)

  },
  beforeDestroy() {
    bus.$off('tecentInitSuccess')
    bus.$off('onCreateLocalStrem')
    bus.$off('onPublishLocalStream')
    bus.$off('onPublishShareStream')
    bus.$off('onReciveRemoteStrem')
    bus.$off('onRemoteStreamRemove')
    bus.$off('onUnPublishShare')

  },
  computed: {
    joinInfo() {
      const {docInfo} = this;
      console.log(docInfo)
      return docInfo;
    }
  },
  methods: {
    async getTencentSign(userId) {
      const {obj} = await this.$http('smarthos.video.tencent.sign', {})
      this.tencentSign = obj
      createClient(userId, this.tencentSign)
    },
    tencentJoinRoom() {
      const {joinInfo, query} = this;
      return joinRoom(query.room, joinInfo.id)
    },
    createlocalMedia(stream) {},
    publishLocal(stream, streamId) {
      const {joinInfo} = this
      this.updateVideo({
        userId: joinInfo.id,
        userName: joinInfo.docName,
        deviceId: streamId,
        type: 'local-video',
        bigScreen: true,
        screenFlag: false,
        stream: stream
      })
    },
    startShare(){
      return createShareStream(this.joinInfo.id)
    },
    UnPublishShare() {
      return createLocalStream(this.joinInfo.id)
    },
    publishLocalShare(stream, streamId) {
      console.log('发布桌面流成功', stream)
      console.log('发布桌面流成功streamId', streamId)
      const {joinInfo} = this
      this.updateVideo({
        userId: joinInfo.id,
        userName: joinInfo.docName,
        deviceId: streamId,
        type: 'local-video',
        bigScreen: true,
        screenFlag: true,
        screenStream: stream
      })

    },
    reciveRemoteMedia(stream, streamId, userId) {
      this.updateVideo({
        userId: userId,
        deviceId: streamId,
        type: 'video',
        stream: stream
      })
    },
    removeRemoteMedia(stream, streamId, userId) {
      let idx = this.videos.findIndex(r => r.userId === userId);
      this.videos.splice(idx, 1);
    },
    /**
     * 增加/更新videos
     * @param video
     */
    updateVideo(video) {
      Log('更新前video数组', this.videos)
      Log('更新updateVideo', video)
      //开始更新数组对象
      const id = video.deviceId || ""
      let idx;
      idx = this.videos.findIndex(r => r.userId === video.userId);
      if (idx >= 0) {//更新
        this.videos.splice(idx, 1, {...this.videos[idx], ...video});
      } else {//增加
        this.videos.push(video);
      }
    },
    async LeaveRoom_() {
      await leaveRoom()
    }

  }
}
